import { render, staticRenderFns } from "./ClinicReport.vue?vue&type=template&id=751234ea&scoped=true&"
import script from "./ClinicReport.vue?vue&type=script&lang=js&"
export * from "./ClinicReport.vue?vue&type=script&lang=js&"
import style0 from "./ClinicReport.vue?vue&type=style&index=0&id=751234ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751234ea",
  null
  
)

export default component.exports